<template>
  <div
    class="kn-progress"
    :class="['kn-progress--' + status, {'kn-progress--pill': pill}]"
    role="progressbar"
    :aria-valuenow="normalized"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    <div class="kn-progress__track" :style="{height: pill ? null : height + 'px'}">
      <div class="kn-progress__fill" :style="{width: normalized + '%'}"></div>
      <span v-if="pill && showValue" class="kn-progress__pill-label">{{ label }}</span>
    </div>
    <span v-if="!pill && showValue" class="kn-progress__label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "progress-bar",
  props: {
    value: {type: [Number, String], default: 0},
    height: {type: Number, default: 6},
    showValue: {type: Boolean, default: true},
    // Значения >100% допустимы (перевыполнение): шкала обрезается, подпись — нет
    max: {type: Number, default: 100},
    pill: {type: Boolean, default: false},
    status: {
      type: String,
      default: 'primary',
      validator: v => ['primary', 'success', 'warning', 'danger'].includes(v),
    },
  },
  computed: {
    numeric() {
      const n = parseFloat(this.value);
      return isNaN(n) ? 0 : n;
    },
    normalized() {
      if (!this.max) return 0;
      return Math.max(0, Math.min(100, (this.numeric / this.max) * 100));
    },
    label() {
      return `${+this.numeric.toFixed(2)}%`;
    },
  },
}
</script>

<style lang="scss">
.kn-progress {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  --kn-progress-color: var(--kn-primary);
  --kn-progress-track: var(--kn-primary-soft);

  &--success { --kn-progress-color: var(--kn-success); --kn-progress-track: var(--kn-success-soft); }
  &--warning { --kn-progress-color: var(--kn-warning); --kn-progress-track: var(--kn-warning-soft); }
  &--danger { --kn-progress-color: var(--kn-danger); --kn-progress-track: var(--kn-danger-soft); }

  &__track {
    position: relative;
    flex: 1;
    min-width: 40px;
    background-color: var(--kn-progress-track);
    border-radius: var(--kn-radius-pill);
    overflow: hidden;
  }

  &__fill {
    height: 100%;
    background-color: var(--kn-progress-color);
    border-radius: inherit;
    transition: width .4s ease;
  }

  &__label {
    flex-shrink: 0;
    min-width: 42px;
    text-align: right;
    font-size: 13px;
    font-weight: 600;
    color: var(--kn-text);
    font-variant-numeric: tabular-nums;
  }

  &--pill &__track {
    height: 26px;
  }

  &--pill &__fill {
    opacity: .35;
  }

  &__pill-label {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    padding-left: 10px;
    font-size: 12px;
    font-weight: 600;
    color: var(--kn-progress-color);
    font-variant-numeric: tabular-nums;
  }
}
</style>
